import { GenieaskTopNavNotificationProps } from '@models/types/genieask.type';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
const GenieaskNotification = React.lazy(
  () => import('genieask/chat-notification'),
);

const NotificationIcon = (props: GenieaskTopNavNotificationProps) => {
  const { isActiveState, headless } = props;
  return (
    <div id="genieask_notification_icon" className="flex-initial lg:ml-6 w-fit">
      <ErrorBoundary fallback={<></>}>
        <Suspense>
          <GenieaskNotification
            isActiveState={isActiveState}
            headless={headless}
          />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default NotificationIcon;
